import * as React from 'react';
import { DefaultButton, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Text } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IField, ITitolario } from '../../shared/interfaces';
import DynamicForm from '../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';


const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}


const initialFields: IField[] = [
    {
        displayName: "Titolo",
        internalName: "title",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
       system: false,
        internalValue: "",
        valid: false,
        touched: false
    }

];

export interface AddEditFilingPlanNodeProps {
    loading?: boolean
    extraCssClass?: string
    selectedFilingPlanNode?: ITitolario
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (filingPlanItem: Partial<ITitolario>) => void
    onDismiss: () => void
    panelIsEdit: boolean
}


const AddEditFilingPlanNode: React.FunctionComponent<AddEditFilingPlanNodeProps> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);


    useEffect(() => {
        setPanelIsOpen(props.panelIsOpen);
        dismissMessageBar();
        onDismiss();
    }, [props.panelIsOpen]); 
    
    useEffect(() => {

        if (props.panelIsEdit && props.selectedFilingPlanNode) {
            let newFields = initialFields.map(el => {
                return el.displayName === 'Titolo' ? {
                    ...el,
                    internalValue: props.selectedFilingPlanNode?.titolo
                } : el
            })

            setFields(newFields);
        } else {
            setFields(initialFields);
        }
        dismissMessageBar();

    }, [props.panelIsEdit, props.selectedFilingPlanNode, props.panelIsOpen]);


    // Click su salva del panel laterale
    const addFilingPlanLateralPanelSubmit = () => {

        if (checkFilingPlanFormValidity()) {
            let newFilingPlanItem: Partial<ITitolario> = {
                titolo: fields.find(el => el.internalName === 'title')?.internalValue,
                parentId: props.selectedFilingPlanNode?.id

            };

            props.onSubmit(newFilingPlanItem);
            resetFormFields();
        }

    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkFilingPlanFormValidity = (): boolean => {

        let isValid = true;


        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onDismiss = () => {
         resetFormFields();
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addFilingPlanLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <Panel
                key='addEditFilingPlanPanel'

                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />

                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                    </div>
                </div>



                {props.selectedFilingPlanNode && !props.panelIsEdit &&
                    <Text variant={'mediumPlus'} styles={textStyles}>Stai creando la nuova voce sotto "{props.selectedFilingPlanNode.titolo}"</Text>}
            </Panel>



        </React.Fragment>


    );

}

export default AddEditFilingPlanNode;
